var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container-sitc" }, [
    _c("div", { staticClass: "filter-container-content" }, [
      _c(
        "div",
        { staticStyle: { padding: "0 40px" } },
        [
          _c("span", { staticClass: "title-h4" }, [
            _vm._v(_vm._s(_vm.$t("demurrageCalculation.title"))),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "search-form",
              attrs: {
                model: _vm.form,
                "label-position": "top",
                rules: _vm.rules,
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("equipmentFee.blNo"),
                            prop: "blNo",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("placeholder.blNo"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.blNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "blNo", $$v)
                              },
                              expression: "form.blNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("equipmentFee.containerNo"),
                            prop: "containerNo",
                            "label-width": "95px",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("placeholder.containerNo"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.containerNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "containerNo", $$v)
                              },
                              expression: "form.containerNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("demurrageCalculation.date"),
                            prop: "calculationDate",
                            "label-width": "105px",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticClass: "pickTime",
                            staticStyle: { width: "100%" },
                            attrs: {
                              "picker-options": _vm.pickerOptions,
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd",
                              type: "date",
                              clearable: "",
                              placeholder: _vm.$t("demurrageCalculation.date"),
                            },
                            model: {
                              value: _vm.form.calculationDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "calculationDate", $$v)
                              },
                              expression: "form.calculationDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        "margin-top": "30px",
                        "text-align": "right",
                      },
                      attrs: { span: 6 },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-primary",
                          attrs: { type: "primary" },
                          on: { click: _vm.toSearch },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("button.search")) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row", { staticClass: "warm-tips" }, [
                _vm._v("\n          " + _vm._s(_vm.$t("equipmentFee.tips_1"))),
                _c("br"),
                _vm._v("\n          (1)  "),
                _c("span", { staticStyle: { color: "blue" } }, [
                  _vm._v(_vm._s(_vm.$t("demurrageCalculation.tips_1"))),
                ]),
                _vm._v("  "),
                _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(_vm._s(_vm.$t("demurrageCalculation.tips_2"))),
                ]),
                _vm._v("  "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("demurrageCalculation.tips_3"))),
                ]),
                _c("br"),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("demurrageCalculation.tips_4"))),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "result-container",
        staticStyle: { "padding-bottom": "20px" },
      },
      [
        _vm.showResult
          ? _c("div", [
              _c(
                "div",
                [
                  _c("h4", [
                    _vm._v(_vm._s(_vm.$t("demurrageCalculation.DEMDETFee"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.demDetFeeData,
                        border: "",
                        "row-class-name": _vm.tableRowClassName,
                        "show-summary": "",
                        "summary-method": _vm.getDemDetSummaries,
                        size: "small",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "index", width: "40" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "blNo",
                          label: _vm.$t("equipmentFee.blNo"),
                          "min-width": "16%",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "containerNo",
                          label: _vm.$t("equipmentFee.containerNo"),
                          sortable: "",
                          "min-width": "14%",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "portName",
                          label: _vm.$t("demurrageCalculation.portName"),
                          "min-width": "11%",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "containerType",
                          label: _vm.$t("equipmentFee.containerType"),
                          "min-width": "7%",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "startMoveDate",
                          label: _vm.$t("equipmentFee.startDate"),
                          sortable: "",
                          "min-width": "12%",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.dateFormat(
                                          "YYYY-MM-DD",
                                          scope.row.startMoveDate
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3193509442
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "endMoveDate",
                          label: _vm.$t("equipmentFee.endDate"),
                          sortable: "",
                          "min-width": "12%",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.dateFormat(
                                          "YYYY-MM-DD",
                                          scope.row.endMoveDate
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2668462413
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "freeUntil",
                          label: _vm.$t("demurrageCalculation.freeUntil"),
                          sortable: "",
                          "min-width": "12%",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.dateFormat(
                                          "YYYY-MM-DD",
                                          scope.row.freeUntil
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2198305305
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "days",
                          label: _vm.$t("demurrageCalculation.days"),
                          sortable: "",
                          "min-width": "9%",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(scope.row.days + " days") +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1074736086
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "overDays",
                          label: _vm.$t("demurrageCalculation.overDays"),
                          sortable: "",
                          "min-width": "9%",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        +scope.row.overDays <= 0
                                          ? "0 days"
                                          : scope.row.overDays + " days"
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          95193401
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "demurrageType",
                          label: _vm.$t("demurrageCalculation.demurrageType"),
                          sortable: "",
                          "min-width": "11%",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "agreementNo",
                          label: _vm.$t("demurrageCalculation.agreementNo"),
                          "min-width": "13%",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "realFee",
                          label: _vm.$t("equipmentFee.amount"),
                          sortable: "",
                          "min-width": "11%",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.toMoney(
                                          scope.row.realFee +
                                            scope.row.amountTax
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          675825025
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "realCurrency",
                          label: _vm.$t("equipmentFee.currency"),
                          "min-width": "7%",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }